import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  MdGpsFixed,
  MdLocalShipping,
  MdPublic,
  MdOutlineToll,
} from "react-icons/md";
import { BsArrowRightShort } from "react-icons/bs";
import { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import Image from "next/image";

//local imports
import classes from "@/styles/fulfilment-partners/ups.module.css";
import { ups, upsUS } from "@/utils/content";
import { upsHeaderImg } from "@/utils/images";
import FulfilmentPartnerHeader from "./fulfilment-partner-header";
import PricingCarousel from "./pricing-carousel";
import { routes } from "@/utils/routes";
import { useIsMobile } from "@/hooks/useIsMobile";
import IntegrationDetails from "../partners/integration-details";
import UPSCountrySelect from "./ups-country-select";

export default function UPSMain() {
  const content = ups.en;
  const usContent = upsUS.en;
  const router = useRouter();
  const isMobile = useIsMobile();

  const [search, setSearch] = useState("");

  const onSearchChange = (e: any) => {
    e.preventDefault();
  };

  const [open, setOpen] = useState("1");
  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div className={classes.container}>
      <FulfilmentPartnerHeader
        title={content.title}
        headerImage={upsHeaderImg}
        height={200}
        width={200}
      />
      <div className="container mt-3">
        <p className={classes.para1}>{content.title2}</p>
        <section className="my-5">
          <Row>
            <Col xs={12} sm={8}>
              <h2 className={classes.about}>{content.aboutUPS}</h2>
            </Col>
            <Col xs={12} sm={4}>
              <UPSCountrySelect />
            </Col>
          </Row>
          <p className={classes.aboutPara}>{content.about}</p>
        </section>
        <section className="my-5 pt-5 pb-5">
          <Row>
            <Col xs={12} lg={6}>
              <h2 className={classes.title3}>{content.title3}</h2>
              <div
                className={classes.para3}
                dangerouslySetInnerHTML={{ __html: content.para3 }}
              ></div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                <Button
                  className={classes.btnBrown}
                  size="lg"
                  onClick={() =>
                    router.push(routes.partners + "/ups/ready-program")
                  }
                >
                  {content.btn1}&nbsp;
                  <BsArrowRightShort size={30} />
                </Button>
              </div>
            </Col>
          </Row>
        </section>
        <section className="my-5 pt-5 pb-5">
          <Row>
            <Col xs={12} lg={6}>
              <div className="mt-5 pt-3">
                <Row>
                  <Col sx={6}>
                    <div className={`d-grid ${classes.cardGrid}`}>
                      <div
                        className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                      >
                        <MdOutlineToll />
                      </div>
                      <p className="ps-3 pt-2 mt-1">{content.card1Title}</p>
                    </div>
                  </Col>
                  <Col sx={6}>
                    <div className={`d-grid ${classes.cardGrid}`}>
                      <div
                        className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                      >
                        <MdGpsFixed />
                      </div>
                      <p className="ps-3 pt-2 mt-1">{content.card2Title}</p>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col sx={6}>
                    <div className={`d-grid ${classes.cardGrid}`}>
                      <div
                        className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                      >
                        <MdPublic />
                      </div>
                      <p className="ps-3">{content.card3Title}</p>
                    </div>
                  </Col>
                  <Col sx={6}>
                    <div className={`d-grid ${classes.cardGrid}`}>
                      <div
                        className={`d-flex align-items-center justify-content-center ${classes.gr2Col1Ico}`}
                      >
                        <MdLocalShipping />
                      </div>
                      <p className="ps-3 pt-2 mt-1">{content.card4Title}</p>
                    </div>
                  </Col>
                </Row>
                {/* <p className="my-5 w-75">{content.disclaimer}{content.disclaimer2}{content.disclaimer3}</p> */}
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <h2 className={classes.title4}>{content.title4}</h2>
              <p className={classes.para4}>{content.para4}</p>
              <ul className={classes.ul}>
                {content.list4.map((l, i) => {
                  return (
                    <li className={classes.li} key={i}>
                      {l}
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </section>
        <section>
          <div className={classes.bigCard}>
            <Row>
              <Col className="pt-5" xs={12} lg={6}>
                <h2 className={classes.bigCard1Title}>
                  {content.bigCard1Title}
                </h2>
                <p className={classes.bigCard1Para}>{content.bigCard1Para}</p>
                <ul className={classes.ul}>
                  {content.bigCard1List.map((l, i) => (
                    <li className={classes.li} key={i}>
                      {l}
                    </li>
                  ))}
                </ul>
                <p>{content.bigCard2Para2}</p>
              </Col>
              <Col xs={12} lg={6}>
                <div className={classes.slider}>
                  <PricingCarousel />
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <section className="my-5 ms-5 ps-5">
          <div className="">
            <h2 className={classes.title4}>{content.title5}</h2>
            <p className={classes.para4}>{content.para5}</p>
            <ul className={classes.ul}>
              {content.list5.map((l, i) => {
                return (
                  <li className={classes.li} key={i}>
                    {l}
                  </li>
                );
              })}
            </ul>
          </div>
        </section>
        {/* <section className="my-5">
          <div className={classes.bigCard}>
            <h2 className={classes.title4}>{content.cardTableHeading}</h2>
            <div className={classes.table}>
              <div className={classes.tableCol}>
                <div className={classes.thead}>{content.canadaToCanada}</div>
                <div className={classes.tbody}>
                  <p>{content.early}</p>
                  <p>{content.earlycc}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.express}</p>
                  <p>{content.expresscc}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.expressSaver}</p>
                  <p>{content.expressSavercc}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.expedited}</p>
                  <p>{content.expeditedcc}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.standard}</p>
                  <p>{content.standardcc}</p>
                </div>
              </div>
              <div className={classes.tableCol}>
                <div className={classes.thead}>{content.canadaToUs}</div>
                <div className={classes.tbody}>
                  <p>{content.early}</p>
                  <p>{content.earlycus}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.express}</p>
                  <p>{content.expressus}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.expressSaver}</p>
                  <p>{content.expressSaverus}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.expedited}</p>
                  <p>{content.expedatedus}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.standard}</p>
                  <p>{content.standardus}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.select}</p>
                  <p>{content.selectUs}</p>
                </div>
              </div>
              <div className={classes.tableCol}>
                <div className={classes.thead}>{content.canadaToCanada}</div>
                <div className={classes.tbody}>
                  <p>{content.early}</p>
                  <p>{content.earlyww}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.express}</p>
                  <p>{content.expressww}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.expressSaver}</p>
                  <p>{content.expressSaverww}</p>
                </div>
                <div className={classes.tbody}>
                  <p>{content.expedited}</p>
                  <p>{content.expedatedww}</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section className="my-5 ms-5 ps-5">
          <h2 className={classes.title4}>{content.title6}</h2>
          <p className={classes.para4}>{content.para6}</p>
          <ul className={classes.ul}>
            {content.list6.map((l, i) => {
              return (
                <li className={classes.li} key={i}>
                  {l}
                </li>
              );
            })}
          </ul>

          <p className={classes.paraNote}>{content.para6note}</p>
        </section>
        <section className="my-5 ms-5 ps-5 pt-5 pb-5">
          <h2 className={classes.title4}>{content.title7}</h2>
          <p className={classes.para4}>{content.para7}</p>
          <ul className={classes.ul}>
            {content.list7.map((l, i) => {
              return (
                <li className={classes.li} key={i}>
                  {l}
                </li>
              );
            })}
          </ul>
        </section>
        <section className="my-5">
          <div className={classes.bigCard}>
            <Row>
              <Col xs={12} lg={6}>
                <h2 className={classes.title4}>{content.bigCard2Col1title}</h2>
                <p className={classes.para4}>{content.bigCard2Col1Para1}</p>
                <p className={classes.para4}>{content.bigCard2Col1Para2}</p>
              </Col>
              <Col className="text-center" xs={12} lg={6}>
                <h2 className={`${classes.title4} m-auto mt-4`}>
                  {content.bigCard2Col2title}
                </h2>
                <p className={`${classes.para4} m-auto mt-4`}>
                  {content.bigCard2Col2Para1}
                </p>
                <form onSubmit={onSearchChange}>
                  <h3 className="mt-5 mb-3">{content.trackingNumber}</h3>
                  <Input
                    type="search"
                    name="search"
                    value={search}
                    onChange={(e: any) => setSearch(e.target.value)}
                  />
                  <Button
                    className={`${classes.btnBrown} m-auto mt-3`}
                    size="md"
                    type="submit"
                  >
                    {content.searchBtn}&nbsp;
                    <BsArrowRightShort size={25} />
                  </Button>
                </form>
              </Col>
            </Row>
          </div>
        </section>
        <section className="my-5 ms-5 ps-5 pt-5 pb-5">
          <h2 className={classes.title4}>{content.title8}</h2>
          <p className={classes.para4}>{content.para8}</p>
          <ol className={classes.ul}>
            {content.list8.map((l, i) => {
              return (
                <li className={classes.li} key={i}>
                  {l}
                </li>
              );
            })}
          </ol>
          <strong>{content.para8Note}</strong>
        </section>
        <section
          className={isMobile ? "pt-5 pb-5" : "my-5 ms-5 ps-5 pt-3 pb-5"}
        >
          <div className="text-center">
            <h2 className={classes.title4}>{content.voidShipment.title}</h2>
            <Link href={routes.cancelShipmentUps} className={classes.para4}>
              {content.voidShipment.linkText}
            </Link>
          </div>
          {content.voidShipment?.cols.map((c: any, i: number) => {
            return (
              <Row className="my-5" key={i}>
                <Col xs={12} lg={6}>
                  {!(i % 2) ? (
                    <Image
                      className={classes.colImg}
                      src={c.img}
                      height={500}
                      width={600}
                      alt={c.title}
                    />
                  ) : (
                    <div className="d-flex gap-3 align-items-center">
                      <p className={classes.colNumber}>{i + 1}</p>
                      <div className="w-75">
                        <h5>{c.title}</h5>
                        <p>{c.para}</p>
                      </div>
                    </div>
                  )}
                </Col>
                <Col xs={12} lg={6}>
                  {i % 2 ? (
                    <Image
                      className={classes.colImg}
                      src={c.img}
                      height={500}
                      width={600}
                      alt={c.title}
                    />
                  ) : (
                    <div className="d-flex gap-3 align-items-center">
                      <p className={classes.colNumber}>{i + 1}</p>
                      <div className="w-75">
                        <h5>{c.title}</h5>
                        <p>{c.para}</p>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            );
          })}
        </section>
        <section className="mt-5 border-top pt-5 pb-5 border-bottom">
          <Row>
            <Col lg={3} xs={12}>
              <h3 className={classes.faqHeading}>{content.faq}</h3>
              <p className={classes.faqPara}>{content.faqPara1}</p>
              <p className={classes.faqPara}>{content.faqPara2}</p>
            </Col>
            <Col lg={9} xs={12}>
              {/*@ts-ignore*/}
              <Accordion open={open} toggle={toggle}>
                {content.faqList.map((f, i) => {
                  return (
                    <AccordionItem key={i}>
                      <AccordionHeader targetId={(i + 1).toString()}>
                        {f.title}
                      </AccordionHeader>
                      <AccordionBody accordionId={(i + 1).toString()}>
                        <p>{f.desc}</p>
                      </AccordionBody>
                    </AccordionItem>
                  );
                })}
              </Accordion>
            </Col>
          </Row>
        </section>
        <section className="my-5 container">
          <h3>{usContent.section6.title}</h3>
          <IntegrationDetails partnerDetails={usContent} />
        </section>
      </div>
    </div>
  );
}
